import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Centered, Column, Loader, Padding } from '../../..'
import { ExclamationCircleIcon, HeaderBar, Suggestions } from './Content.style'
import { useSize } from '../../../utils'
import ContentButton from '../../../../containers/Content/Content/ContentButton'
import CurrentLayer from './CurrentLayer'

const LayerSection = ({
    hasPermissionToApproveLayers,
    isWorking,
    onApproveLayerClick,
    onChangeLayers,
    onDownloadLayer,
    onOpenFormLayers,
    onRemoveLayers,
    onTextChangeLayers,
    optionsLayers,
    selectedLayer,
}) => {
    const { t } = useTranslation()
    const { isMobile } = useSize()
    const [isEditing, setIsEditing] = React.useState(false)

    const onClickSelectedLayer = () => {
        setIsEditing(true)
    }

    const showSelectedLayer = selectedLayer && !isEditing
    const editLayer = !selectedLayer || isEditing

    return (
        <>
            <HeaderBar />
            <Padding top left right size="xs" height={isMobile ? '110px' : '65px'}>
                <Padding top size="xs">
                    <Padding right size="ssm">
                        {isWorking && (
                            <Centered horizontal>
                                <Loader />
                            </Centered>
                        )}
                        {!isWorking && (
                            <>
                                <Column left width={isMobile ? '100%' : '80%'} style={{ verticalAlign: 'bottom' }}>
                                    {showSelectedLayer && (
                                        <Column left width="100%" style={{ verticalAlign: 'middle' }}>
                                            <Padding left size="sm">
                                                <CurrentLayer layer={selectedLayer} onClick={onClickSelectedLayer} />
                                            </Padding>
                                        </Column>
                                    )}
                                    {editLayer && (
                                        <Column left width="100%" style={{ maxWidth: '400px' }}>
                                            <Padding left size="sm">
                                                <Suggestions
                                                    type="suggestions"
                                                    onChange={onChangeLayers}
                                                    onTextChange={onTextChangeLayers}
                                                    options={optionsLayers}
                                                    placeholder={selectedLayer ? selectedLayer.name : 'Add existing layer...'}
                                                    size="full"
                                                />
                                            </Padding>
                                        </Column>
                                    )}
                                </Column>
                                <Column
                                    center={isMobile}
                                    right={!isMobile}
                                    width={isMobile ? '100%' : '20%'}
                                >
                                    <ContentButton onClick={onOpenFormLayers} title="Add layer">
                                        <FontAwesomeIcon icon="plus" size="1x" />
                                    </ContentButton>
                                    <ContentButton
                                        onClick={() => onDownloadLayer(0)}
                                        disabled={!selectedLayer}
                                        title={selectedLayer && "Download layer"}
                                    >
                                        <FontAwesomeIcon icon="download" size="1x" />
                                    </ContentButton>
                                    <ContentButton
                                        onClick={() => {
                                            if (window.confirm ("Are you sure you wish to delete this layer?")) {
                                                onRemoveLayers(0)
                                                alert('Layer deleted')
                                            }
                                        }}
                                        disabled={!selectedLayer}
                                        theme="secondaryDanger"
                                        title={selectedLayer && "Delete layer"}
                                    >
                                        <FontAwesomeIcon icon="trash-alt" size="1x" />
                                    </ContentButton>
                                </Column>
                                {selectedLayer && !selectedLayer.is_approved && !selectedLayer.isWorking && (
                                    <Padding bottom size="xs">
                                        <Button
                                            onClick={hasPermissionToApproveLayers ? onApproveLayerClick : null}
                                            theme="light"
                                            disabled={!hasPermissionToApproveLayers}
                                            fullWidth
                                        >
                                            <ExclamationCircleIcon />
                                            {hasPermissionToApproveLayers && t('NotApprovedLayerPermission')}
                                            {!hasPermissionToApproveLayers && t('NotApprovedLayer')}
                                        </Button>
                                    </Padding>
                                )}
                            </>
                        )}
                    </Padding>
                </Padding>
            </Padding>
        </>
    )
}

LayerSection.propTypes = {
    hasPermissionToApproveLayers: PropTypes.bool,
    isWorking: PropTypes.bool,
    onApproveLayerClick: PropTypes.func,
    onChangeLayers: PropTypes.func,
    onDownloadLayer: PropTypes.func,
    onOpenFormLayers: PropTypes.func,
    onRemoveLayers: PropTypes.func,
    onTextChangeLayers: PropTypes.func,
    optionsLayers: PropTypes.arrayOf(PropTypes.shape({})),
    selectedLayer: PropTypes.shape({}),
}

LayerSection.defaultProps = {
    hasPermissionToApproveLayers: false,
    isWorking: false,
    onApproveLayerClick: () => null,
    onChangeLayers: () => null,
    onDownloadLayer: () => null,
    onOpenFormLayers: () => null,
    onRemoveLayers: () => null,
    onTextChangeLayers: () => null,
    optionsLayers: [],
    selectedLayer: null,
}

export default LayerSection
